// This is a simple wrapper around LD's useFlags
// The purpose is twofold:
// - ensure the term "featureflag" is searchable in the code (instead of just "flag")
// - use JSDoc to provide a reminder to keep DEFAULT_FEATURE_FLAG_VALUES in sync
//   - this will be shown if/when you hover over `useFeatureFlags`
// Note: this comment is not included in the JSDoc block below because we don't want this showing up in intellisense/tooltips
import { useFlags } from 'launchdarkly-react-client-sdk'

import { type GremlinClientFlags } from 'components/LaunchDarklyProvider'

/**
 * MAKE SURE YOU UPDATE `DEFAULT_FEATURE_FLAG_VALUES` IN `src/components/LaunchDarklyProvider.tsx`
 */
export function useFeatureFlags() {
  // can't call this conditionally, but we can just ignore its return value when we're in onprem mode
  const ldFlags = useFlags<GremlinClientFlags>()

  return window.onpremConfig?.featureFlags ?? ldFlags
}
